//
// routes.tsx
// marcio.garcia@newsoftware.com.br
//

import React from "react";
import { createBrowserRouter } from "react-router-dom";
import { PrivateRoute, LoginPage, ContentPage, UnauthorizedPage } from '@newsoftware-platform/newsoftware-lib-ui';

export const createAppRouter = (load: string, globalRequired: string) => createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  { path: "/unauthorized", element: <UnauthorizedPage /> },
  { 
    path: "/", 
    element: (
      <PrivateRoute requered={globalRequired}>
        <ContentPage load={load}  />
      </PrivateRoute>
    ) 
  },
  { 
    path: "/search/:name", 
    element: (
      <PrivateRoute requered={globalRequired}>
        <ContentPage load={load}  />
      </PrivateRoute>
    ) 
  },
  { 
    path: "/content/:type/:name", 
    element: (
      <PrivateRoute requered={globalRequired}>
        <ContentPage load={load} />
      </PrivateRoute>
    ) 
  },
  { 
    path: "/private/:name", 
    element: (
      <PrivateRoute requered="TRUE">
        <ContentPage load={load}  />
      </PrivateRoute>
    ) 
  },
  { 
    path: "*", 
    element: (
      <PrivateRoute requered={globalRequired}>
        <ContentPage load={load}  />
      </PrivateRoute>
    ) 
  },
]);